export default __webpack_public_path__ + "static/media/apple_logo_black.8fbc3843.svg";